import * as React from "react";
import { Badge } from "@/components/ui/badge";
const timelineData = [{
  year: "2025",
  title: "Porselen Lamina Uygulamalarında Güncel Yaklaşımlar",
  institution: "Dent Ankara Eğitim ve Danışmanlık - Uluslararası Sertifikasyon"
}, {
  year: "2024",
  title: "Dijital Diş Hekimliği ve İş Akışları",
  institution: "International Team for Implantology - ITI Section 2024"
}, {
  year: "2024",
  title: "Current Techniques in Implant Surgery",
  institution: "MIA World Symposium - Masters Implant Academy - Uluslararası Sertifikasyon"
}, {
  year: "2024",
  title: "Açık Sinüs Lifting - İleri Cerrahi Teknikler",
  institution: "Opus İmplant - Sertfikasyon Programı"
}, {
  year: "2023",
  title: "Endodonti Sanatı",
  institution: "Solution Partner Academy - Sertifikasyon Programı"
}, {
  year: "2023",
  title: "Dental Botoks Eğitimi",
  institution: "Solution Partner Academy - Uluslararası Sertifikasyon"
}, {
  year: "2021",
  title: "Advance İmplant Surgery on Model",
  institution: "MGM İmplant - Meet Academy"
}, {
  year: "2020",
  title: "Guide Cerrahi Eğitimi",
  institution: "Paltop Dental Company - Çağdaş Diş Hekimleri Derneği - Uluslararası Sertifikasyon"
}, {
  year: "2020\xA0",
  title: "Dental Fotoğrafçılık Eğitimi",
  institution: "Paltop Dental Company - Çağdaş Diş Hekimleri Derneği - Uluslararası Sertifikasyon"
}, {
  year: "2020",
  title: "Klinik ve Dijital İmplantoloji Teknikleri",
  institution: "Paltop Dental Company - Çağdaş Diş Hekimleri Derneği - Uluslararası Sertifikasyon"
}, {
  year: "2019",
  title: "A dan Z ye İmplantoloji",
  institution: "İmplant Direct - Pi Akademik Eğitim Hizmetleri -Uluslararası Sertifikasyon"
}, {
  year: "2019",
  title: "Implant Surgery Techniques",
  institution: "Osstem Meeting - Uluslararası Sertifikasyon Programı"
}, {
  year: "2013 - 2018",
  title: "Diş Hekimliği Fakültesi (Lisans)",
  institution: "Gaziantep Üniversitesi Diş Hekimliği Fakültesi"
}];
export default function ProfessionalTraining() {
  return <section data-section-id="141756" id="eğitim-ve-sertifikalar" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <div className="text-center mb-16 md:mb-20">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground font-serif mb-4">
            Eğitim ve Sertifikalar
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-sans">
            Gülüşünüzü emanet ettiğiniz profesyonelliğin temelinde, yılların akademik birikimi ve uluslararası düzeydeki uzmanlık eğitimleri yatmaktadır.
          </p>
        </div>

        <div className="relative border-l border-primary/30 ml-4 md:ml-8">
          {timelineData.map((item, i) => <div key={i} data-index={i} className="mb-12 relative pl-8 md:pl-12 last:mb-0 group transition-all duration-300">
              {}
              <div className="absolute w-3 h-3 bg-primary rounded-full -left-[6.5px] top-1.5 ring-4 ring-background shadow-md transition-transform group-hover:scale-125" />
              
              {}
              <div className="flex flex-col gap-1.5">
                <span className="text-base font-serif text-primary tracking-wider uppercase">
                  {item.year}
                </span>
                <h3 className="text-2xl font-semibold text-foreground leading-tight font-serif group-hover:text-primary transition-colors">
                  {item.title}
                </h3>
                <p className="text-muted-foreground text-base font-sans italic">
                  {item.institution}
                </p>
              </div>
            </div>)}

          {}
          <div className="relative pl-8 md:pl-12 mt-16">
            <div className="absolute w-3 h-3 bg-primary/40 rounded-full -left-[6.5px] top-1/2 -translate-y-1/2 ring-4 ring-background" />
            <Badge variant="secondary" className="rounded-sm px-6 py-2 text-xs font-sans font-semibold tracking-widest uppercase bg-secondary text-secondary-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-500 shadow-sm">
              Sürekli Mesleki Gelişim
            </Badge>
          </div>
        </div>
      </div>
    </section>;
}